const translations = {
  "en": {
    "Return to all collections": "Return to all collections"
  },
  "zh-tw": {
    "Return to all collections": "返回所有收藏集"
  }
};

export default translations;
